import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { TableHead } from '../../components/ui/table';
import type { SortConfig, SortKey } from './candidateListUtils';

interface SortableTableHeaderProps {
  align?: 'center' | 'left';
  className?: string;
  label: string;
  sortConfig: SortConfig;
  sortKey: SortKey;
  onSort: (key: SortKey) => void;
}

export function SortableTableHeader({
  align = 'center',
  className = '',
  label,
  sortConfig,
  sortKey,
  onSort,
}: SortableTableHeaderProps) {
  const active = sortConfig.key === sortKey;
  const Icon = active ? (sortConfig.direction === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown;

  return (
    <TableHead className={`px-6 ${align === 'center' ? 'text-center' : 'text-left'} ${className}`}>
      <button
        type="button"
        className={`inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider hover:text-primary ${
          align === 'center' ? 'justify-center' : 'justify-start'
        }`}
        onClick={() => onSort(sortKey)}
      >
        {label}
        <Icon size={12} className={active ? 'text-primary' : 'text-text-subtle/70'} />
      </button>
    </TableHead>
  );
}
